import { Box } from "@mui/material";
import React from "react";
import Client from "./Client";
import UserTabs from "./UserTabs";

export default function ClientHeader(props) {
  return (
    <React.Fragment>
      <Box padding={1} />
      <Client />
      <Box padding={1} />
      <UserTabs {...props} />
      <Box padding={1} />
    </React.Fragment>
  );
}
